import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';

const ReportsWrapper = styled('div')`
  position: relative;
  overflow-x: hidden;

  h1 {
    font-size: var(--ph-heading-three);
    font-weight: 400;
    color: var(--black);
    padding: 0;
    margin: 0;
  }
`;

const Left = styled('div')`
  padding: 25px;
  margin-right: 50px;
  background-color: var(--white);
  border-right: 1px solid rgba(var(--black), 0.1);
  height: 100%;
`;

const Right = styled('div')`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 50px;
  padding: 25px 10px 10px 12px;
  background-color: rgba(var(--ph-gray-rgb-50), 0.2);
`;

const ButtonsRow = styled('div')`
  display: flex;
  margin: 20px 0 30px;
`;

const QuickJumpLabel = styled('span')`
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  color: #7a7a80;
  margin-right: 15px;
`;

const GreySwitchButton = styled('span')`
  width: 67px;
  height: 26px;
  border-radius: var(--ph-border-radius-sm);
  background-color: #f2f2f2;
  color: #66605c;
  padding: 6px 12px;
  margin: 5px;
  cursor: pointer;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;

  &:hover,
  &.selected {
    background-color: var(--ph-gray-500);
    color: var(--white);
  }
`;

const Report = styled('div')`
  width: 100%;
  padding: 15px;
  box-shadow: var(--ph-box-shadow-sm);
`;

const DownloadWrapper = styled('div')`
  margin-left: auto;
  position: relative;
  top: -5px;
`;

const DownloadBtn = styled(Button)`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-sm);
  color: var(--white);
  background-color: var(--ph-orange-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  height: 32px;
  min-width: 32px;
  padding-left: 30px;
  padding-right: 12px;
  border: 0;
  cursor: pointer;

  &:hover {
    background-color: var(--ph-orange-700);
  }

  &:active {
    background-color: var(--ph-orange-900);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

`;

const DownloadIcon = styled(Svg)`
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translate(0%, -50%);
  width: 12px;
`;

const DownloadType = styled('div')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-gray-50);
  padding-right: 16px;
  padding-left: 16px;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  display: inline-flex;
  margin-right: 15px;
`;

const CollapsedBtn = styled('div')`
  transition: var(--ph-button-transition);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  background-color: var(--ph-gray-50);
  border-radius: var(--ph-border-radius-sm);
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 7px;
  padding-right: 7px;
  writing-mode: vertical-lr;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  transform: rotate(180deg);

  &:hover {
    background-color: var(--ph-gray-100);
    color: var(--ph-gray-700);
  }

  &:active {
    background-color: var(--ph-gray-200);
    color: var(--ph-gray-900);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

  &.lang-cn {
    transform: rotate(0deg);
  }
`;

const InfoOverlay = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40%;
  min-width: 500px;
  background-color: var(--white);
  padding: 30px 40px;
  border: solid 1px #e4e4e4;
  transition: right 0.3s;
  z-index: 9999;

  &::before {
    display: block;
    content: '';
    position: absolute;
    right: 100%;
    top: -1px;
    bottom: -1px;
    width: 80px;
    opacity: 0.1;
    background-image:
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        var(--ph-gray-500) 100%
      );
  }

  &.hidden {
    right: -100%;
    visibility: hidden;
  }
`;

const InfoOverlayContent = styled('div')`
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 30px 40px;

  div[class*="ReportReviewBlock"] + div[class*="ReportReviewBlock"] {
    margin-top: 20px;
  }
`;

const CloseBtn = styled(Svg)`
  width: 15px;
  height: 15px;
  cursor: pointer;
  position: absolute;
  top: 48px;
  right: 40px;

  path {
    fill: var(--dark-grey);
  }
`;

const AddNoteButtonWithTitleDiv = styled('div')`
  display: flex;
  width: 100%;
  white-space: nowrap;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;

  &.noFlex {
    display: block;
  }
`;

const AddButtonWrapper = styled('div')`
  cursor: pointer;
  margin-right: 25px;
`;

const AddButton = styled(Svg)`
  width: 22px;
  margin: 15px 0 0 0;

  circle {
    fill: var(--ph-light-blue-500);
  }
`;

const AddButtonLabel = styled('span')`
  position: relative;
  top: -5px;
  margin-left: 5px;
`;

const QuestionTitle = styled('div')`
  font-size: var(--ph-text-sm);
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  color: var(--black);
`;

export default {
  ReportsWrapper,
  Left,
  Right,
  ButtonsRow,
  QuickJumpLabel,
  GreySwitchButton,
  Report,
  DownloadWrapper,
  DownloadBtn,
  DownloadIcon,
  DownloadType,
  CollapsedBtn,
  InfoOverlay,
  InfoOverlayContent,
  CloseBtn,
  AddNoteButtonWithTitleDiv,
  AddButtonWrapper,
  AddButton,
  AddButtonLabel,
  QuestionTitle,
};
